import modalData from './../modalData'
import scoreData from './../scoreData'
import { Scores } from './Scores'
import { TweenLite, Linear } from 'gsap'

class Modals {
  constructor () {
    this.scores = new Scores()

    this.modalData = modalData
    this.scoreData = scoreData
    this.modalController = document.querySelector('.modal-controls')
    this.modalContainer = document.querySelector('.modal-container')
    this.modalContainerWrap = document.querySelector('.modal-container__wrap')
    this.modalMask = document.querySelector('.modal-mask')

    this.buttons = []

    this.animationSpeed = 0.15
    this.animationEasing = Linear.easeNone
    this.animationScale = { min: 0.8, max: 1 }
  }

  addToPage (page, delay = 500) {
    const _buttonFragment = document.createDocumentFragment()

    if (this.modalData[page]) {
      this.buttons = []

      let i = 1
      for (const a of this.modalData[page]) {
        let _button = document.createElement('a')
        _button.classList.add('modal__button')
        _button.classList.add(`modal__button--${a.type}`)
        _button.classList.add(`modal__button--${a.modal}`)
        _button.dataset.num = i + ''
        _button.style.left = a.x
        _button.style.top = a.y

        if (this.scores.getAnswer(page, a.modal)) {
          if (this.scores.checkAnswer(page, a.modal)) {
            _button.classList.add('modal__button--correct')
            _button.classList.remove('modal__button--wrong')
          } else {
            _button.classList.remove('modal__button--correct')
            _button.classList.add('modal__button--wrong')
          }
        }

        // save the button for later
        this.buttons.push(_button)

        // add it to the document fragment
        _buttonFragment.appendChild(_button)

        // then bind it to a modal window!
        this.bindButtonEvents(_button, a.modal, page, a.type)
        i++
      }

      this.modalController.appendChild(_buttonFragment)
      this.showButtons(delay)
    } else {
      console.log('The page passed doesn\'t have any modals defined')
    }
  }

  bindButtonEvents (button, modal, page, type) {
    button.addEventListener('click', (e) => {
      e.preventDefault()

      const getContent = new Promise((resolve, reject) => {
        let uri = `/static/modals/${page}/${modal}.html`
        let request = new XMLHttpRequest()

        request.open('GET', uri, true)
        request.onload = () => {
          if (request.status >= 200 && request.status < 400) {
            resolve(request.response)
          } else {
            reject(request.statusText)
          }
        }
        request.send()
      })

      getContent.then((content) => {
        const _modalFragment = document.createDocumentFragment()

        // set up close button and add click event
        let _modalClose = document.createElement('a')
        _modalClose.classList.add('modal__button')
        _modalClose.classList.add('modal__button--close')
        _modalClose.addEventListener('click', (e) => {
          e.preventDefault()
          this.hideModal()
        })
        _modalClose.addEventListener('mouseover', (e) => {
          TweenLite.to(e.target, 0.01, {
            scale: 1.1,
            ease: this.animationEasing
          })
        })
        _modalClose.addEventListener('mouseout', (e) => {
          TweenLite.to(e.target, 0.01, {
            scale: 1,
            ease: this.animationEasing
          })
        })

        // set up content
        let _modalContent = document.createElement('div')
        _modalContent.classList.add('modal__content')
        _modalContent.innerHTML = content

        let _modalQuiz = this.getQuestion(page, modal)

        // append the content to the window
        _modalFragment.appendChild(_modalClose)
        _modalFragment.appendChild(_modalContent)

        if (_modalQuiz) {
          _modalFragment.appendChild(_modalQuiz)
        }

        this.modalContainerWrap.appendChild(_modalFragment)

        if (_modalQuiz) {
          this.scores.updateAnswer(page, modal, null)
        }

        // show the mask and the window...
        this.showModal()
      }).catch((error) => {
        console.log(`Unable to get modal content: ${error}`)
      })
    })

    button.addEventListener('mouseover', (e) => {
      e.target.style.animation = 'none'
      TweenLite.to(e.target, 0.01, {
        scale: 1.1,
        ease: this.animationEasing
      })
    })

    button.addEventListener('mouseout', (e) => {
      TweenLite.to(e.target, 0.01, {
        scale: 1,
        ease: this.animationEasing
      })
    })

    // hide modal when clicking the mask
    this.modalMask.addEventListener('click', () => this.hideModal())

    // hide modal on 'esc'
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideModal()
      }
    })
  }

  getQuestion (page, modal) {
    if (this.scoreData[page] && this.scoreData[page][modal]) {
      let quiz = this.scoreData[page][modal]

      let _quizContent = document.createElement('div')
      _quizContent.classList.add('quiz')
      _quizContent.classList.add(page)
      _quizContent.classList.add(modal)

      let _quizBlock = document.createElement('div')
      _quizBlock.classList.add('quiz__block')
      _quizBlock.classList.add('quiz__block--question')

      let _header = document.createElement('div')
      _header.classList.add('quiz__content')

      let _headerTitle = document.createElement('h2')
      _headerTitle.innerText = 'Question'
      _header.appendChild(_headerTitle)

      let _headerQuestion = document.createElement('p')
      _headerQuestion.innerHTML = quiz.question
      _header.appendChild(_headerQuestion)

      let _footer = document.createElement('ul')
      _footer.classList.add('quiz__options')

      let i = 0
      for (const o of quiz.options) {
        let _footerOption = document.createElement('li')
        _footerOption.classList.add('quiz__item')

        let _optionButton = document.createElement('button')
        _optionButton.setAttribute('type', 'button')
        _optionButton.dataset.id = (i + 1)
        _optionButton.dataset.page = page
        _optionButton.dataset.modal = modal
        _optionButton.dataset.pip = this.scores.getLetter(i)
        _optionButton.classList.add('quiz__button')
        _footerOption.classList.add('quiz__button--' + o.size)
        _optionButton.innerHTML = o.title

        _footerOption.appendChild(_optionButton)
        _footer.appendChild(_footerOption)

        i++
      }

      _quizBlock.appendChild(_header)
      _quizBlock.appendChild(_footer)
      _quizContent.appendChild(_quizBlock)

      let _quizAnswer = this.getAnswer(page, modal, quiz)
      _quizContent.appendChild(_quizAnswer)

      return _quizContent
    }

    return null
  }

  getAnswer (page, modal, quiz) {
    let _quizBlock = document.createElement('div')
    _quizBlock.classList.add('quiz__block')
    _quizBlock.classList.add('quiz__block--answer')

    let _content = document.createElement('div')
    _content.classList.add('quiz__content')

    let _contentImage = document.createElement('figure')
    _contentImage.classList.add('quiz__image')
    _contentImage.classList.add('quiz__image--' + modal)
    _content.appendChild(_contentImage)

    let _contentTitle = document.createElement('h2')
    _contentTitle.innerHTML = '<span class="quiz__title-type quiz__title-type--correct">Correct</span>' +
                              '<span class="quiz__title-type quiz__title-type--incorrect">Incorrect</span>' +
                              ' - ' + this.scores.getLetter(quiz.correct) + ''
    _content.appendChild(_contentTitle)

    let _contentSummary = document.createElement('p')
    _contentSummary.innerText = quiz.answer
    _content.appendChild(_contentSummary)

    _quizBlock.appendChild(_content)

    return _quizBlock
  }

  showButtons (delay) {
    let i = 0
    const fadeIn = () => {
      this.buttons[i++].classList.add('modal__button--active')
      if (i < this.buttons.length) {
        setTimeout(() => {
          requestAnimationFrame(fadeIn)
        }, 200)
      }
    }
    setTimeout(() => {
      requestAnimationFrame(fadeIn)
    }, delay)
  }

  showModal () {
    // show the window
    TweenLite.fromTo(this.modalContainer, this.animationSpeed, {
      opacity: 0,
      scale: this.animationScale.min,
      y: '-50%',
      ease: this.animationEasing
    }, {
      opacity: 1,
      scale: this.animationScale.max,
      y: '-50%',
      ease: this.animationEasing,
      onStart: () => {
        this.modalContainer.classList.add('modal-container--active')
      }
    })

    // show the mask
    TweenLite.to(this.modalMask, this.animationSpeed, {
      opacity: 1,
      ease: this.animationEasing,
      onStart: () => {
        this.modalMask.classList.add('modal-mask--active')
      }
    })
  }

  hideModal () {
    // hide the window
    TweenLite.to(this.modalContainer, this.animationSpeed, {
      opacity: 0,
      scale: this.animationScale.max,
      ease: this.animationEasing,
      onComplete: () => {
        this.modalContainer.classList.remove('modal-container--active')
        this.modalContainerWrap.innerHTML = ''
      }
    })

    // hide the mask
    TweenLite.to(this.modalMask, this.animationSpeed, {
      opacity: 0,
      ease: this.animationEasing,
      onComplete: () => {
        this.modalMask.classList.remove('modal-mask--active')
      }
    })
  }

  remove () {
    if (this.buttons.length > 0) {
      for (const button of this.buttons) {
        this.modalController.removeChild(button)
      }
    }
  }
}

export { Modals }



// WEBPACK FOOTER //
// ./src/classes/Modals.js